
        import Symbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-rescls-qgis_vector_style",
  "use": "icon-rescls-qgis_vector_style-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"icon-rescls-qgis_vector_style\"><path fill=\"#AEC8E0\" d=\"m21.5 4.5 1-1.5s.3-.701 0-1.001c-.4-.4-1.378-.093-1.5 0-.392.297-1 .501-1.5 1.001 0 0 1 .5 1.5 1z\" /><path fill=\"#00B066\" d=\"M6.4 15c-5.6.5-3.2 5.4-6.4 7 4.2 0 8.5-.8 8.7-4.7-.1-.2-2.3-2.3-2.3-2.3\" /><path fill=\"#3498DB\" d=\"m19.488 12.676-.97-.969h-2.3v2.398l.954.97v-2.399z\" /><path fill=\"#3498DB\" d=\"M16.547 15.666a4.7 4.7 0 0 1-1.085.131c-2.694 0-4.977-2.218-4.977-5.076s2.25-5.01 4.96-5.01 4.863 2.152 4.863 5.01c0 .46-.065.92-.164 1.33l2.48 2.481c.641-1.1 1.003-2.415 1.003-3.828C23.627 6.302 20.11 3 15.397 3c-4.682 0-8.198 3.286-8.198 7.704 0 4.452 3.516 7.787 8.198 7.787a9.2 9.2 0 0 0 3.35-.624z\" /><path fill=\"#3498DB\" d=\"M20.325 13.498h-2.333v2.399L21.113 19h2.497v-2.25zM15.4 10.886h2.283l-1.117-1.1h-2.382v2.299l1.215 1.216z\" /><path fill=\"#AEC8E0\" d=\"m13.5 9 3-2.501s.979.17 1.5.501c.466.297.5.5.5.5L17 9zM13.492 9l-2.382 2.5s.105.952.39 1.5c.255.49.5.5.5.5l1.19-1.013z\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-rescls-qgis_vector_style"/>
                </svg>
            );
        };

        Icon.id = "icon-rescls-qgis_vector_style";

        export default Icon;
    